import { render, staticRenderFns } from "./EventReserveForm.vue?vue&type=template&id=424e1bf3"
import script from "./EventReserveForm.vue?vue&type=script&lang=js"
export * from "./EventReserveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports